import { getEntityRef } from "@client/content/lib/helper";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import appInfo from "@common/appInfo";
import { setActiveAction } from "../../actions";
import { localStateSelector } from "../../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = RootContainerProps & {
  onCancel?: () => void;
  parentTicketCommentId?: string | null;
  onReplyClick: (ticketCommentId: string) => void;
  onUpdateClick: (ticketCommentId: string) => void;
};

const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();

  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      apiInfo: apiInfoSelector(state, props),
      comments: localState.comments,
      isLoading: localState.status === "LoadingComments",
      lastAddedCommentId: localState.lastAddedCommentId,
      userId: appInfo.user?.id
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onDeleteClick: (ticketCommentId: string) =>
    dispatch(setActiveAction(getEntityRef(props), { target: "comment", type: "delete", targetId: ticketCommentId })),
  onReplyClick: props.onReplyClick,
  onUpdateClick: props.onUpdateClick
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
